import { VueQueryPlugin } from '@tanstack/vue-query'

const options = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 0,
        gcTime: 0,
        refetchOnWindowFocus: 'always',
        refetchOnMount: 'always',
        refetchOnReconnect: 'always',
        retry: 0,
      },
      mutations: {
        retry: 0,
      },
    },
  },
}

export default (app) => {
  app.use(VueQueryPlugin, options)
}